import React from 'react';
import Highlighter from 'react-highlight-words';
import ListSearch from '../list/ListSearch';

const VendorSearch = props => {
  const renderSuggestion = (suggestion, { query }) => {
    const result = {};

    const style = {
      fontSize: '12px',
    };

    ['itemid', 'City', 'Name', 'Phone', 'State', 'Zipcode', 'Address'].forEach((part) => {
      result[part] = suggestion[part];
      if (result[part]) {
        result[part] = (
          <Highlighter
            autoEscape
            highlightClassName="hl"
            searchWords={query.replace(':', '').split(/\s/)}
            textToHighlight={`${suggestion[part]}`}
          />
        );
      }
    });

    return (
      <div>
        <div><b>{result.Name}</b> ({result.itemid})</div>
        {result.Address && (
          <div style={style}>{result.Address}</div>
        )}
        {(result.City || result.State || result.Zip) && (
          <div style={style}>{result.City}, {result.State} {result.Zip}</div>
        )}
        {result.Phone && (
          <div style={style}><i className="zmdi zmdi-phone" style={style} /> {result.Phone}</div>
        )}
      </div>
    );
  };

  return (
    <ListSearch
      {...props}
      renderSuggestion={renderSuggestion}
    />
  );
};

export default VendorSearch;
